import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import Button from "../../../buttons/Button/Button.js";
import Group from "../../../layout/Group/Group.js";
import Heading from "../../../typography/Heading/Heading.js";
import { rem } from "@mantine/core";
import ContentLinks from "./ContentLinks.js";
import { F as FooterStyles } from "../../../../Footer.module-DJ70l-Jq.js";
const OtherSites = ({ sites, header }) => /* @__PURE__ */ jsxs(Fragment, { children: [
  /* @__PURE__ */ jsxs(
    Group,
    {
      className: FooterStyles.otherSites,
      hiddenFrom: "xs",
      p: rem("40px"),
      spacing: rem("16px"),
      align: "center",
      justify: "center",
      children: [
        /* @__PURE__ */ jsx(Heading, { type: "h5", text: header, align: "center", variant: "light", tt: "uppercase" }),
        sites.map((site) => /* @__PURE__ */ jsx(
          Button,
          {
            text: site.text,
            variant: "outline",
            contrast: "dark",
            href: site.href,
            target: "_blank",
            fullWidth: true,
            icon: "ArrowUpRight",
            pl: 0,
            pr: 0
          },
          site.text + site.href
        ))
      ]
    }
  ),
  /* @__PURE__ */ jsx(
    ContentLinks,
    {
      links: [{ header, items: sites.map((site) => ({ ...site, variant: "external" })) }],
      visibleFrom: "xs"
    }
  )
] });
export {
  OtherSites as default
};
